import { VideoState } from "./VideoSlice"
import { VideoMetadata } from "@nova/slice-video"
import { fileManagementApi } from "features/data-management/files/fileManagementApi"
import { parseTelemetry } from "@nova/telemetry-parsing"
import { stagedFiles, UploadState } from "@nova/slice-multifile-upload"
import { toVideoMetadata, parseTelemetryFile } from "./telemetry"
import { selectWorkspaceRegion } from "features/data-management/workspace/WorkspaceManagementSlice"
import store from "integrations/redux/store"
import { getSampleDataBucket } from "@nova/util-s3"

// this isn't going to work when embedded srt parsing comes in, and we will have to move from the ICF flow to the VCF flow
export const getLocalVideoData = async (
    uploads: UploadState<VideoState>[]
): Promise<[string, VideoMetadata | undefined, string]> => {
    const videoFile = uploads?.find((upload) =>
        stagedFiles[upload.id].name.toLowerCase().includes(".mp4")
    )
    if (!videoFile)
        throw new Error("Tried to load local video data when mp4 does not exist in uploads")
    const videoUrl = URL.createObjectURL(stagedFiles[videoFile.id])
    const videoName = stagedFiles[videoFile.id].name
    const srtFile = uploads?.find(
        (upload) => !stagedFiles[upload.id].name.toLowerCase().includes(".mp4")
    )
    return [videoUrl, await parseTelemetryFile(srtFile && stagedFiles[srtFile.id]), videoName]
}

export const getV1VideoData = async (videoPath: string) => {
    return (await Promise.all(
        [videoPath, videoPath.split("/").slice(0, -1).join("/") + "/data.srt"].map(async (key) => {
            if (key.toLowerCase().includes(".mp4")) {
                const url = (await fileManagementApi.getDownloadUrl(key)) as {
                    location?: string
                }
                return url?.location as string
            } else {
                const remoteFile = await fileManagementApi.fetchFile(key)

                const srtData = await remoteFile.text()
                return toVideoMetadata(parseTelemetry(srtData))
            }
        })
    )) as [string, VideoMetadata]
}

export const createFMVFileUrl = async (s3Key: string, isDemo?: boolean): Promise<string> => {
    let url: string

    if (isDemo) {
        const region = selectWorkspaceRegion()(store.getState())
        const bucketName = getSampleDataBucket(region)
        url = `https://${bucketName}.s3.${region}.amazonaws.com/${s3Key}`
    } else {
        url = await fileManagementApi.getDownloadUrl(s3Key)
    }

    return url
}
